
import { WORKFLOW_SYSTEM } from "../../constants";
import LogoIcon from "../../assets/images/icons/logo.svg";
import OracleIcon from "../../assets/images/home/apps/OracleIcon.svg";
import PowerTrackerIcon from "../../assets/images/home/apps/PowerTrackerIcon.svg";
import NetZeroIcon from "../../assets/images/home/apps/NetZeroIcon.svg";
import CarbonRevDisabledIcon from "../../assets/images/home/apps/CarbonRevDisabledIcon.svg";
import SoonIcon from "../../assets/images/home/apps/SoonIcon.svg";
import EventsRevIcon from "../../assets/images/home/apps/EventsRevIcon.svg";
import UnitRevIcon from "../../assets/images/home/apps/UnitRevIcon.svg";
import SolarCopilotIcon from "../../assets/images/home/apps/SolarCopilotIcon.svg";
import WorkspaceIcon from "../../assets/images/home/apps/WorkspaceIcon.svg";
import SupplyPortalIcon from "../../assets/images/home/apps/SupplyPortalIcon.svg";
import PricingCopilotIcon from "../../assets/images/home/apps/PricingCopilotIcon.svg";
import ConsumptionCopilotIcon from "../../assets/images/home/apps/ConsumptionCopilotIcon.svg";
import { PAGES } from "../../pages";

export const scaleRevenuePortalsApps = {
  title: "Scale rev portals",
  apps: [
    {
      title: "Oracle",
      progress: 30,
      icon: OracleIcon,
      link: "https://oracle.propertypwr.com",
      disabled: false,
    },
    {
      title: "Power",
      subTitle: "Tracker",
      progress: 70,
      icon: PowerTrackerIcon,
      link: "https://power-tracker.propertypwr.com",
      disabled: false,
    },
  ]
}

export const saveTheWorldApps = {
  title: "Save the World",
  apps: [
    {
      title: "NetZero",
      subTitle: "Co-pilot",
      progress: 30,
      icon: NetZeroIcon,
      link: "",
      disabled: false,
    },
    {
      title: "Carbon",
      subTitle: "Revenues",
      progress: 70,
      icon: CarbonRevDisabledIcon,
      link: "",
      disabled: true,
    },
    {
      title: "Carbon",
      subTitle: "Revenues",
      progress: 70,
      icon: SoonIcon,
      link: "",
      disabled: true,
    },
  ]
}

export const powerRevenuePortalsApps = {
  title: "Power Revenues",
  apps: [
    {
      title: "Events Rev.",
      progress: 30,
      icon: EventsRevIcon,
      link: "https://app.dgtlpower.com/power-revenues/events",
      disabled: false,
    },
    {
      title: "Unit Rev.",
      progress: 70,
      icon: UnitRevIcon,
      link: "",
      disabled: false,
    },
    {
      title: "Solar",
      subTitle: "Co-pilot",
      progress: 30,
      icon: SolarCopilotIcon,
      link: "",
      disabled: false,
    },
    {
      title: "Batteries",
      subTitle: "Co-pilot",
      progress: 70,
      icon: SoonIcon,
      link: "",
      disabled: true,
    },
    {
      title: "Demand",
      subTitle: "Response",
      progress: 70,
      icon: SoonIcon,
      link: "",
      disabled: true,
    },
  ]
}

export const propertiesPortalApps = {
  title: "Property Power",
  apps: [
    {
      title: "Workspace",
      progress: 30,
      icon: WorkspaceIcon,
      disabled: false,
      id: "praas-workspace-card",
      page: `${PAGES.workspace.index}/${PAGES.workspace.tasks}`,
      system_type: WORKFLOW_SYSTEM,
    },
    {
      title: "Properties",
      subTitle: "Science",
      progress: 70,
      icon: LogoIcon,
      id: "praas-buildings",
      page: `${PAGES.buildings.index}`,
    },
  ]
}

export const supplyPortalApps = {
  title: "Supply portals",
  apps: [
    {
      title: "Supply Portal",
      progress: 30,
      icon: SupplyPortalIcon,
      link: "https://app.dgtlpower.com",
      disabled: false,
    },
    {
      title: "Pricing Co-pilot",
      progress: 30,
      icon: PricingCopilotIcon,
      link: "https://app.dgtlpower.com/power-revenues/events",
      disabled: false,
    },
    {
      title: "Consumption",
      subTitle: "Co-pilot",
      progress: 30,
      icon: ConsumptionCopilotIcon,
      link: "https://app.dgtlpower.com/consumption-co-pilot/actual",
      disabled: false,
    },
  ]
}

